import { MenuItem, FormGroup, Checkbox, Box, Button, DialogActions, 
  DialogContent, DialogTitle, Grid,Typography } from '@mui/material';
import React, { FC, useEffect, useMemo, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import Divider from '@mui/material/Divider';
import LoadingButton from '@mui/lab/LoadingButton';

import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import TagFacesIcon from '@mui/icons-material/TagFaces';

import { useAppDispatch, useAppSelector, } from "../../store/hooks";
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";

import { ApiStatus } from "../../utils/api.types";
import { InvoicePreviewResponse, ShareInvoiceForm } from '../../utils/invoice.types'
import { dispatchInvoice, shareInvoicePaymentReceipt } from '../../store/invoiceStore/invoiceThunk';
import { fetchAccountSettings } from '../../store/accountThunk';
import { stat } from 'fs';
import { forEach, method, template } from 'lodash';
import { Utils } from "../../utils/common-utils";
import CustomTextField from '../FormFields/CustomTextField';
import { dispatchSale } from '../../store/estimateStore/estimateThunk';
import { toast } from 'react-toastify';
import CloseIcon from '@mui/icons-material/Close';
import { Share } from '@mui/icons-material';
import Estimate from '../Invoice/Estimate';

interface DialogShareProps {
  dispatchType: string;
  invoiceId: string;
  invoicePreviewData: InvoicePreviewResponse;
  openDrawer: boolean;
  selectedBuyer: any;
  onClose: () => void;
}

const initialState = {
  email: true,
  sms: false,
  whatsapp: false,
};

interface ChipData {
  key: number;
  label: string;
}

const ListItem = styled('li')(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

const DialogShareInvoiceReciept: FC<DialogShareProps> = ({ dispatchType, openDrawer, invoiceId, invoicePreviewData, selectedBuyer, onClose }) => {

  const dispatch = useAppDispatch();

  const { status } = useAppSelector(state => state.cashInflow);
  const { selectedAccount } = useAppSelector(state => state.auth);

  const [headerName, setHeaderName] = useState('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [sharePreview, setSharePreview] = useState<any>(invoicePreviewData);
  const [pdfLocation, setPdfLocation] = useState<string>("");
  const [shareInvoiceId, setShareInvoiceId] = useState<string>(invoiceId);


  const [toEmail, setToEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [emailSubject, setEmailSubject] = useState("");
  const [emailBody, setEmailBody] = useState("");

  const [state, setState] = useState(initialState);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { email, sms, whatsapp } = state;

  // Per-account WhatsApp toggle for this share type. null = still loading.
  // 'Payment Receipt' shares are gated by the paymentReceived setting; everything
  // else (invoice) by the invoiceCreated setting. Matches the backend WA_NOTIFICATION_TYPE keys.
  const waSettingKey = dispatchType === 'Payment Receipt' ? 'paymentReceived' : 'invoiceCreated';
  const [waEnabled, setWaEnabled] = useState<boolean | null>(null);

  // const [chipData, setChipData] = useState<readonly ChipData[]>([
  //   { key: 0, label: 'Purushottam.Bitle@lntinfotech.com' },
  //   { key: 1, label: 'jQuery' },
  //   { key: 2, label: 'Polymer' },
  //   { key: 3, label: 'React' },
  //   { key: 4, label: 'Vue.js' },
  // ]);

  const [chipData, setChipData] = useState<readonly ChipData[]>([]);
  const elmRef = useRef<any>(null);

  // Schema to validate reciept form.
  const schema = yup.object().shape({
    toEmail: yup.string().required("Please enter the comma separated email ids. Example: abc@gmail.com, xyz@gamil.com")
  });

  const methods = useForm<any>({ resolver: yupResolver(schema) });
  const {control, register} = methods;

  const handleDeleteChip = (chipToDelete: ChipData) => () => {
    setChipData((chips) => chips.filter((chip) => chip.key !== chipToDelete.key));
  };

  // const handleAddChip = (chipToAdd: ChipData) => () => {
  //   setChipData((chips) => chips.filter((chip) => chip.key !== chipToAdd.key));
  // };

  const handleKeyDown = (event: any) => {
    // event.preventDefault()
    if (["Enter", "Tab", ","].includes(event.key)) {
      var value = event.target.value.trim();
      if (value && cehckIsValid(value)) {
        setChipData([...chipData, {key: chipData.length, label: value}])
        methods.setValue("toEmail", '');

      }
      return true;
    }
  };

  const cehckIsValid = (emailString: any) => {
    let error = null;
    if (isInList(emailString)) {
      error = `${emailString} has already been added.`;
    }else if (!isEmailValid(emailString)) {
      error = `${emailString} is not a valid email address.`;
    }
    if (error) {
      toast.error(error)
      return false;
    }
    return true;
  }

  const isInList = (emailString: any) => {
    // let chips = chipData.map((chip) => chip.label);

    let chips = chipData.map(({ key, label }) => {
      return label;
    });
    return chips.includes(emailString);
  }

  const isEmailValid = (emailString: any) => {
    return /[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/.test(emailString);
  }


  useEffect(() => {
    console.log(selectedBuyer);
    if (!sharePreview) {
      toast.error("PDF Preview Data is empty");
    }
//     let _subject = selectedAccount.name + ": " + sharePreview.key.split("/")[1].slice(0, -4);;
//     let _body = `Please find our payment receipt attached to this email

    
// Thank you for the business.
    
// Regards       
// ` + selectedAccount.name;

    // methods.setValue("toEmail", selectedBuyer.email);
    console.log(sharePreview?.Location);
    setPdfLocation(sharePreview?.Location);
    // setToEmail(selectedBuyer.email);
    setMobile(selectedBuyer?.whatsAppNumber);
    // setEmailSubject(_subject);
    // setEmailBody(_body);
    setShareInvoiceId(invoiceId);
    setHeaderName(dispatchType);

    console.log(selectedBuyer?.email);
    console.log(selectedBuyer?.whatsAppNumber);

    let emailData: any = [];

    if (selectedBuyer?.email instanceof Array ) {
      console.log(" array of instance ");
      emailData = selectedBuyer.email
    } else if ( typeof selectedBuyer?.email === 'string' || selectedBuyer?.email instanceof String ) {
      console.log(" array of string ");
      emailData = selectedBuyer.email.split(',')
    }
    let chips = []
    for (let i=0; i<emailData.length; i++) {
      console.log(emailData[i]);
      chips.push({key: i, label: emailData[i]})
    }
    console.log(chips);
    setChipData(chips);
  }, [methods]);

  // Load this account's WhatsApp notification setting for the relevant message type.
  // If it's OFF, the WhatsApp share option is disabled so the user can't send via WhatsApp.
  useEffect(() => {
    const accountId = selectedAccount?._id;
    if (!accountId) return;
    let active = true;
    (async () => {
      try {
        const res: any = await dispatch(fetchAccountSettings(accountId)).unwrap();
        const enabled = !!res?.settings?.whatsappNotifications?.[waSettingKey];
        if (active) {
          setWaEnabled(enabled);
          // If WhatsApp was somehow pre-checked but the account disabled it, force it off.
          if (!enabled) setState((prev) => ({ ...prev, whatsapp: false }));
        }
      } catch (error) {
        console.error('Failed to load WhatsApp share setting:', error);
        if (active) setWaEnabled(false); // fail closed — default is OFF
      }
    })();
    return () => { active = false; };
  }, [selectedAccount?._id, waSettingKey]);


  const handleShareInvoiceDrawerClose = () => {
    console.log("handleShareInvoiceDrawerClose onClose called ....")
    setState(initialState);
    setAnchorEl(null);
    setPdfLocation('');
    onClose();
    setIsLoading(false);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    
    console.log("======== chekcing -")
    console.log(event.target.checked)
    console.log(event.target.name)
    console.log("======== end -")
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
  };

  const onSubmitHandler = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    console.log("form submitted");
    //Form submission happens here
  }

  const inputChangeHandler = (setFunction: React.Dispatch<React.SetStateAction<string>>, event: React.ChangeEvent<HTMLInputElement>) => {
    setFunction(event.target.value)
  }

  const removeExtraSpace = (s: String) => s.trim().split(/ +/).join(' ');

  const isValidEmail = (email: any) => {
    return /\S+@\S+\.\S+/.test(email);
  }

  const onSubmit = async (data: any) => {
    console.log(data);
    setIsLoading(true);
    console.log(" onSubmit called 222222");

    // let currentValues = methods.getValues();
    // let toEmailValue = removeExtraSpace(currentValues.toEmail)
    // let mailerList = toEmailValue.split(',');
    // let isMailerListValid =  false;
    // // validate email id
    // mailerList.map((mailId: any) => {
    //   if (!isValidEmail(mailId)) {
    //     toast.error("Invalid Email: " + mailId);
    //     isMailerListValid = false;
    //     return
    //   } else {
    //     isMailerListValid = true;
    //   }
    // });

    // if (!isMailerListValid) {
    //   setIsLoading(false);
    //   return
    // }

    let mailerList = chipData.map(({ key, label }) => {
      return label;
    });
    if (mailerList.length == 0 ) {
      toast.error("Please enter atleast one receipent");
      setIsLoading(false);
      return
    }

    // Add queryParams for selected share methods ( email, sms, whatsapp)
    let queryParams = '';
    if (email) queryParams = `email=${email}`;
    if (sms) queryParams += `&sms=${sms}`;
    if (whatsapp) queryParams += `&whatsapp=${whatsapp}`;
    if (!sms && !whatsapp && !email) {
      toast.error("Please check atleast one method (Email, SMS or Whatsapp) ");
      setIsLoading(false);
      return
    }

    let routePath = '';
    if (dispatchType && dispatchType == '') {
      toast.error("Invalid dispatch type. Contact Administrator for support" + dispatchType);
    }

    console.log(queryParams)

    await dispatch(dispatchInvoice(
      { invoiceId: shareInvoiceId, 
        params: queryParams, 
        dispatchPayload: { 
          templateId: sharePreview.templateId, 
          toEmailList: mailerList,
          dispatchType: dispatchType
        } 
      }))
      .then(async (data: any) => {
        console.log(data.payload);
        if (data.payload) {
          methods.reset();
          setIsLoading(false);
          // handleShareInvoiceDrawerClose(); 
        } else {
          setIsLoading(false);
        }
    });
    // setIsLoading(false);




    // if (dispatchType == 'Estimate' || dispatchType == 'Credit Note' || dispatchType == 'Non GST Invoice' ) {
    //   console.log("called estimate/credit-note dispatch");
      
    //   await dispatch(dispatchSale(
    //     { saleId: invoiceId, saleType: routePath, params: queryParams, dispatchPayload: { templateId: sharePreview.templateId, toEmailList: mailerList } }))
    //     .then(async (data: any) => {
    //       if (data.payload) {
    //         methods.reset();
    //         setIsLoading(false);
    //         handleShareInvoiceDrawerClose(); 
    //       } else {
    //         setIsLoading(false);
    //       }
    //   });

    // } else if (dispatchType == 'Sale Invoice') {
    //   await dispatch(dispatchInvoice(
    //     { invoiceId: invoiceId, params: queryParams, dispatchPayload: { templateId: sharePreview.templateId, toEmailList: mailerList } }))
    //     .then(async (data: any) => {
    //       if (data.payload) {
    //         methods.reset();
    //         setIsLoading(false);
    //         handleShareInvoiceDrawerClose(); 
    //       }
    //   });
    // } else if (dispatchType == 'Payment Receiptww') {
    //   // Share Payment Receipt Invoice
    //   let shareInvoiceReqObj: ShareInvoiceForm = {
    //     "toEmail": mailerList,
    //     "subject": emailSubject,
    //     "mobile": Number(mobile),
    //     "body": emailBody,
    //     "account": selectedAccount._id,
    //     "invoiceId": shareInvoiceId,
    //     "templateId": sharePreview.templateId,
    //     "isSms": sms,
    //     "isEmail": email,
    //     "isWhatsapp": whatsapp
    //   };
    //   await dispatch(shareInvoicePaymentReceipt(shareInvoiceReqObj)).then(async (data: any) => { 
    //     if (data.payload) {
    //       methods.reset();
    //       setIsLoading(false);
    //       handleShareInvoiceDrawerClose(); 
    //     } else { setIsLoading(false); }
    //   });
    // }

    // } else {
    //   toast.error("Invalid Request Module :  " + dispatchType);
    //   setIsLoading(false);
    //   return
    // }
  };

  return (
    <div className="drawer-form-container">
      <FormProvider {...methods}>
        <Box
          sx={{ display: "flex", flexDirection: "column", height: "100vh", padding: "16px 0 16px 16px" }}
          component="form"
          onSubmit={(e:any) => {e.preventDefault();}}
          noValidate>
          {/* <LoadingButton 
                      variant='outlined'
                      onClick={handleShareInvoiceDrawerClose}
                      style={{ marginRight: '10px', width: '250px' }}>
                      Cancel
            </LoadingButton> */}
            <DialogTitle>
              <Box sx={{ display: "flex", mt: 2, justifyContent: "space-between" }}>
                
                <Typography variant="h4"> Share {headerName}</Typography>
                <CloseIcon style={{flex: 'end'}}  onClick={handleShareInvoiceDrawerClose} color={'error'} />
              </Box>
              <Divider style={{width: '100%', margin: '20px 5px 20px 0px'}}/>
              
            </DialogTitle>

            <DialogContent>

            <Grid container justifyContent="center" spacing={2} rowSpacing={-2}>
                {/* <StyledSectionTable> */}
                <Grid item xs={12} display="flex" justifyContent="flex-end" >
                  <Grid container justifyContent="left" spacing={2} rowSpacing={-2}>


                  <Grid item xs={12} md={12} sm={12} lg={12} style={{paddingBottom: "10px"}}>
                    {/* <Typography>{chipData}</Typography> */}
                    <Paper
                      sx={{
                        display: 'flex',
                        justifyContent: 'left',
                        flexWrap: 'wrap',
                        listStyle: 'none',
                        p: 0.5,
                        m: 0, 
                        backgroundColor: '#008aff17'
                      }}
                      component="ul"
                    >
                      {chipData.map((data) => {
                        let icon;

                        if (data.label === 'React') {
                          icon = <TagFacesIcon />;
                        }

                        return (
                          <ListItem key={data.key}>
                            <Chip
                              icon={icon}
                              label={data.label}
                              color='secondary'
                              onDelete={data.label === 'React' ? undefined : handleDeleteChip(data)}
                            />
                          </ListItem>
                        );
                      })}
                    </Paper>
                  </Grid>

                  <Grid item xs={12} md={12} sm={12} lg={12}>
                  {/* <Typography>{JSON.stringify(chipData)}</Typography> */}
                  </Grid>
                    <Grid item xs={12} md={12} sm={12} lg={12}>
                      {/* <Typography></Typography>
                      <Typography>{pdfLocation}</Typography> */}
                      <CustomTextField style={{ margin: '5px 0px 30px 0px' }}
                        variant="outlined"
                        label="Enter comma separated Email IDs"
                        name="toEmail"
                        onKeyDown={(e: any) => handleKeyDown(e)}
                        // ref={elmRef}
                        InputLabelProps={{ shrink: true }} />
                    </Grid>
                    {/* <Grid item xs={12} md={12} sm={12} lg={12}>
                      <CustomTextField style={{ margin: '5px 0px 30px 0px' }}
                        variant="outlined"
                        label="Subject"
                        name="emailSubject"
                        value={emailSubject}
                        InputLabelProps={{ shrink: true }} />
                    </Grid>
                    <Grid item xs={12} md={12} sm={12} lg={12}>
                      <CustomTextField style={{ margin: '5px 0px 30px 0px' }}
                        label="Body"
                        multiline
                        name="Body"
                        required
                        variant="outlined"
                        value={emailBody}
                      />
                    </Grid> */}
                    <MenuItem key={'email'}><Checkbox checked={email} onChange={handleChange} name='email'/> {'Email'}</MenuItem>
                    <MenuItem key={'whatsapp'} disabled={waEnabled !== true}>
                      <Checkbox checked={whatsapp} onChange={handleChange} name='whatsapp' disabled={waEnabled !== true} />
                      {'WhatsApp'}
                      {waEnabled === false && (
                        <Typography variant="caption" sx={{ ml: 1, color: 'text.secondary' }}>
                          (disabled in Settings)
                        </Typography>
                      )}
                    </MenuItem>
                    <MenuItem key={'sms'}><Checkbox checked={sms} onChange={handleChange} name='sms' disabled /> {'SMS'}</MenuItem>
                    
                  </Grid>
                </Grid>
            </Grid>
            <Box>
              <object style={{ height: "70vh", width: "50vw" }} data={pdfLocation} type="application/pdf" >
              </object>
            </Box>
            {/* <Typography>{pdfLocation}</Typography> */}
            
            </DialogContent>

            <DialogActions sx={{ height: "40px", mb: 2 }}>
              <Grid container gap='0' sx={{ mr: '32px', pt: '10px' }}>
              <Divider style={{width: '100%', margin: '20px 5px 15px'}}/>
                <Grid item xs={12} md={12} sm={12} lg={12} display="flex" justifyContent="flex-end" >

                {/* <Button variant='contained' color='error'
                    style={{ marginRight: '10px' }}
                    onClick={() => {
                      handleShareInvoiceDrawerClose();
                    }}>Close</Button>

                <Button variant='contained'
                  style={{ marginRight: '10px' }} 
                  onClick={(e) => handleShareInvoiceDrawerClose()}>Send Invoice/Reciept</Button> */}

                <Button variant='contained' color='error'
                  style={{ marginRight: '10px' }}
                  onClick={() => {
                    methods.reset();
                    handleShareInvoiceDrawerClose();
                  }}>Close</Button>
                <LoadingButton
                  type="button"
                  onClick={onSubmit}
                  variant="contained"
                  loading={isLoading}>
                  Share {headerName}
                </LoadingButton>
                    
                </Grid>
              </Grid>
            </DialogActions>
        </Box>
      </FormProvider>
    </div>
  );
};

export default DialogShareInvoiceReciept;
